import {
  set,
  getOr,
  has,
  map,
  some,
  reject,
  concat,
  values,
  isEmpty,
  orderBy,
  flow
} from 'lodash/fp';
import createOrderItemKey from '../createOrderItemKey';

export default function applyOrderItemsAdjustment(orderItems, orderAdjustment) {
  const hasAdjustment = some(each => !isEmpty(each), orderAdjustment);
  if (hasAdjustment) {
    const applyAdded = concat(values(orderAdjustment.add));
    const applyUpdates = map(({ quantity, ...item }) =>
      set(
        'quantity',
        getOr(
          quantity,
          `update.${createOrderItemKey(item)}.quantity`,
          orderAdjustment
        ),
        item
      )
    );
    const applyDeleted = reject(item =>
      has(createOrderItemKey(item), orderAdjustment.delete)
    );

    return flow(
      applyAdded,
      applyUpdates,
      applyDeleted,
      orderBy('createdAt', 'desc')
    )(orderItems);
  }

  return orderBy('createdAt', 'desc', orderItems);
}
